import { render, staticRenderFns } from "./LastOrderIcon.vue?vue&type=template&id=371142ca"
import script from "./LastOrderIcon.vue?vue&type=script&lang=js"
export * from "./LastOrderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports